module.exports = __webpack_public_path__ + "img/4M.e3caf1a0.png";